import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import ExpandCollapseCell from 'src/components/custom-cells/ExpandCollapseCell';
import useVarianceDetails from 'src/hooks/useVarianceDetails';

const VarianceColumnsCell = (props: GridCellProps) => {
  const { dataItem } = props;
  const { setVarianceLineItems } = useVarianceDetails();

  let { expanded = false, rowId } = dataItem;

  const handleExpendClick = useCallback(() => {
    setVarianceLineItems((prev) =>
      [...prev].map((item) =>
        item?.rowId === rowId ? { ...item, expanded: !item.expanded } : item
      )
    );
  }, [rowId, setVarianceLineItems]);
  return (
    <GridCellBase {...props} className="k-hierarchy-cell" disableToolTip>
      <ExpandCollapseCell
        title="Expand/Collapse"
        expand={expanded}
        onExpand={handleExpendClick}
        plusIconColor="#0e80b4"
        minusIconColor="#0e80b4"
      />
    </GridCellBase>
  );
};

export default VarianceColumnsCell;
